import React, { useState } from "react";
import { Image, ModalProps } from "react-bootstrap";

import "./DownloadApkModal.scss";
import ImageFileMightBeHarmful from "../../../../images/file-might-be-harmul-image.png";
import ImageSSL from "../../../../images/ssl-image.png";
import ImageFacePile from "../../../../images/face-pile.png";
import { useDownloadApp } from "../../../../hooks/useDownloadApp";
import { showSuccessToast } from "../../../../utils/show-toast";
import BottomModal from "../../../../components/BottomModal/BottomModal";
import ImageBackIcon from "../../../../images/arrow-left-black.svg";
import GhostButton from "../../../../components/dashboard-page/GhostButton/GhostButton";
import ImageInfoIcon from "../../../../images/info-icon-brand-dark.svg";
import FixedFooter from "../../../../components/FixedFooter/FixedFooter";
import { getVendorLogo } from "../../../../utils/vendor";
import LinkButton from "../../../../components/Buttons/LinkButton/LinkButton";
import WhyUseApkModal from "../WhyUseApkModal/WhyUseApkModal";
import AppIsDownloadingModal from "../AppIsDownloadingModal/AppIsDownloadingModal";

function DownloadApkModal({ show, onHide }: ModalProps) {
  const { apk } = useDownloadApp();
  const [isApkUseModalOpen, setIsApkUseModalOpen] = useState(false);
  const [isDownloadingModalOpen, setIsDownloadingModalOpen] = useState(false);

  function handleStartDownloadClick() {
    setIsDownloadingModalOpen(true);
    showSuccessToast("Download Started");
  }

  return (
    <BottomModal show={show} style={{ top: 0, background: "white" }}>
      <div className="MobileOnly download-apk-modal position-relative">
        <p className="d-flex mb-3 ps-2">
          <GhostButton
            aria-label="go back"
            onClick={onHide}
            className="d-inline"
          >
            <Image src={ImageBackIcon} width={30} height={30} alt="back" />
          </GhostButton>{" "}
        </p>
        <div className="px-3">
          <h3 className="mb-2">
            Hyper is available only as an Android APK due to real money gaming
            rewards.
            <GhostButton
              aria-label="view info"
              style={{
                display: "inline-block",
                padding: 0,
                position: "relative",
                top: -4,
              }}
              onClick={() => setIsApkUseModalOpen(true)}
            >
              <Image src={ImageInfoIcon} alt="info" height={18} width={18} />
            </GhostButton>
          </h3>
          <p className="tap-download-instructions text-black">
            Tap <b>"Download anyway"</b> when you see this pop up 👇
          </p>
          <Image
            src={ImageFileMightBeHarmful}
            alt="file-might-be-harmful-image"
            className="file-harmful-image"
          />
          <Image src={ImageSSL} alt="ssl image" className="ssl-image mt-4" />
          <FixedFooter className="px-3">
            <div className="trusted-by-box  MobileOnly">
              <p className="trusted-by-statement text-black">
                {" "}
                <b>Trusted by over 10 thousand users </b>
              </p>
              <Image className="face-pile" src={ImageFacePile} alt="faces" />
            </div>
            <LinkButton href={apk.url} onClick={handleStartDownloadClick}>
              <Image src={getVendorLogo(null)} alt="android" />
              <span>Download Secure APK</span>
            </LinkButton>
          </FixedFooter>
        </div>
      </div>
      <WhyUseApkModal
        show={isApkUseModalOpen}
        onHide={() => setIsApkUseModalOpen(false)}
      />
      <AppIsDownloadingModal
        show={isDownloadingModalOpen}
        onHide={() => setIsDownloadingModalOpen(false)}
        onHideParent={onHide}
      />
    </BottomModal>
  );
}

export default DownloadApkModal;
